<template>
  <div class="">
    <b-button v-b-toggle.placeSchedules class="btn btn-lg btn-collapse">
      {{ $t("placesSchedules.placesSchedules") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="placeSchedules">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placeScheduleView"
              v-model="usersPrivilegePlaceSchedule.placeScheduleView"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placeScheduleView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placeScheduleAdd"
              v-model="usersPrivilegePlaceSchedule.placeScheduleAdd"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placeScheduleAdd">{{
              $t("add")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placeScheduleUpdate"
              v-model="usersPrivilegePlaceSchedule.placeScheduleUpdate"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placeScheduleUpdate">{{
              $t("edit")
            }}</label>
          </div>

          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placeScheduleArchive"
              v-model="usersPrivilegePlaceSchedule.placeScheduleArchive"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placeScheduleArchive">{{
              $t("archive")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placeScheduleDelete"
              v-model="usersPrivilegePlaceSchedule.placeScheduleDelete"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placeScheduleDelete">{{
              $t("finalDelete")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placeScheduleRestore"
              v-model="usersPrivilegePlaceSchedule.placeScheduleRestore"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placeScheduleRestore">{{
              $t("restore")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-4">
            <input
              type="checkbox"
              id="placeScheduleApproved"
              v-model="usersPrivilegePlaceSchedule.placeScheduleApproved"
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placeScheduleApproved">{{
              $t("approved")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegePlaceSchedule",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegePlaceSchedule"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
